import { RPCResponseMultiCallError } from '../../../../utils/errors'
export type RPCResponseStatus = 'success' | 'failure'

/**
 * Boundary to catch RPC errors before continuing code path
 * @param items
 * @returns
 */
export const rpcResponseErrorBoundary = <T extends { error?: Error; status: RPCResponseStatus }>(
  items: T[],
): boolean => {
  const errors = items
    .filter((item) => item.status === 'failure')
    .map(({ error }) => error?.message ?? 'Unknown error')

  if (errors.length !== 0) {
    throw new RPCResponseMultiCallError(errors)
  }
  return true
}
